import { IPropertyOption } from './IPropertyOption.interface';

export interface IProperty {
    name: string;
    property: string;
    type?: 'label' | 'text' | 'date' | 'select' | 'file' | 'remove' | 'amount';
    headerType?: 'string' | 'date' | 'hidden';
    action?: string;
    required?: boolean;
    options?: IPropertyOption[]; // Options for Select/Radio
    multiple?: boolean; // Multi select
    languages?: string[]; // For translatable fields
    disabled?: boolean;
    default?: string;
    hasTotal?: boolean;
    highlighted?: boolean;
    flex?: number;
    hasReference?: boolean;
}
